<template>
  <project-base :state="state">
    <article class="container">
      <h2 class="text-3xl mb-12">
        {{ contract.title }}
      </h2>
      <div class="flex items-start">
        <nav
          class="hidden lg:block w-1/3 sticky"
          style="top: 6rem"
        >
          <h3 class="text-base border-b mb-6 pb-2 mt-1">
            Contract Sections
          </h3>
          <ul class="list-reset">
            <li 
              v-for="({heading}, index) in contract.sections" 
              :key="index"
              class="mb-2"
            >
              <a
                data-turbolinks="false"
                :href="'#section_' + index"
              >{{ heading }}</a>
            </li>
            <!-- <li 
              v-if="project.conditions"
              class="mb-2"
            >
              <a
                data-turbolinks="false"
                href="#section_appendix"
              >Appendix: Conditions</a>
            </li> -->
          </ul>
        </nav>
        <div class="flex-1 md:pl-8">
          <div
            v-for="(section, index) in contract.sections" 
            :key="index"
            :class="{
              'mt-12': index > 0
            }"
          >
            <h3 
              :id="'section_' + index" 
              class="mb-6 text-xl border-b pb-2"
            >
              {{ section.heading }}
            </h3>
            <div
              class="content contract"
              v-html="parseMarkdown(section.content)"
            />
          </div>
          <!-- <div
            v-if="project.conditions"
            class="mt-12"
          >
            <h3 
              id="section_appendix"
              class="mb-6 text-xl border-b pb-2"
            >
              Appendix: Contractual Conditions
            </h3>
            <div
              class="content contract"
              v-html="parseMarkdown(project.conditions)"
            />
          </div> -->
        </div>
      </div>
      <div class="md:w-2/3 md:ml-auto mt-12 md:pl-8">
        <div class="w-64">
          <app-button
            @click="acceptChanges"
          >
            Accept Changes
          </app-button>
        </div>
      </div>
    </article>
  </project-base>
</template>
<script>
import { userProjectMixin } from '../../mixins/userProject.js'
export default {
  name: 'ReviewContract',
  mixins: [userProjectMixin],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    acceptChanges() {
      // TODO: Reload page with new state on successful save 👍
      axios.post(window.location.href)
        .then(data => {
          console.log(data)
          Turbolinks.visit(route('projects.contracts.index', this.project.uuid))
        })
        .catch(error => {
          console.error(error)
          this.loading = false;
        })
    }
  }
}
</script>
